(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('kiosks', {
                parent: 'app',
                url: '/kiosks?page&sort&search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.kiosk.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/kiosks/kiosks.html',
                        controller: 'KiosksController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('kiosks');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('kiosks-detail', {
                parent: 'kiosks',
                url: '/kiosks/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.kiosk.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/kiosks/kiosks-detail.html',
                        controller: 'KiosksDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('kiosks');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Kiosks', function ($stateParams, Kiosks) {
                        return Kiosks.get({id: $stateParams.id});
                    }]
                }
            })
            .state('kiosks-new', {
                parent: 'kiosks',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.kiosk.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/kiosks/kiosks-dialog.html',
                        controller: 'KiosksDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('kiosks');
                        return $translate.refresh();
                    }],        entity: function () {
                        return {
                            id: null
                        };
                    },
                    domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                        var deferred = $q.defer();
                        Principal.identity().then(function (account) {
                            deferred.resolve(TabDomains.get({id: account.context.id}));
                        });
                        return deferred.promise;
                    }]}

            })
            .state('kiosks.delete', {
                parent: 'kiosks',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/kiosks/kiosks-delete-dialog.html',
                        controller: 'KiosksDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('kiosks');
                                return $translate.refresh();
                            }],
                            entity: ['Kiosks', function (Kiosks) {
                                return Kiosks.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('kiosks', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            }).state('kiosks-dashboards', {
            parent: 'kiosks',
            url: '/kiosk-dashboard',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.kiosk.detail.title'
            },
            params : {
                showCreation: {
                    value: true,
                    squash: true
                }
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard.html',
                    controller: 'KiosksDashboardsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates: $stateParams.predicates,
                        search: $stateParams.search,
                        showCreation : $stateParams.showCreation
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
